import {Grid} from '../grid'
import {Typography} from '../typography'
import {classes} from './ShowError.classes'

export type Props = {errorMessage?: string}

export function ShowError({errorMessage}: Props) {
  const defaultErrorMessage = 'Cannot load map'
  return (
    <Grid alignItems="center" className={classes.root} justify="center" container>
      <Typography color="minor" variant="caption1">
        {errorMessage ?? defaultErrorMessage}
      </Typography>
    </Grid>
  )
}
